<dashboard-grid [setup]="setup()" [size]="size()" [rows]="rows()" (selectedRows)="getSelectedRows($event)"></dashboard-grid>